import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7jqwqwjp5c: FaireBrandEntity = {
  token: "b_7jqwqwjp5c",
  type: "brand",
  name: "Aromalee Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/d229b58ffdd0e3bad2a0da7e2f5f3e669394f5618748695cf974ffd77c13ce25.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/424590d027f2b81048cd93806a5351ebfbc69dbc26555f2b74feb0e311ccd4b2.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d229b58ffdd0e3bad2a0da7e2f5f3e669394f5618748695cf974ffd77c13ce25.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/424590d027f2b81048cd93806a5351ebfbc69dbc26555f2b74feb0e311ccd4b2.jpeg",
  location: "Minneapolis , MN, USA",
  minimumOrderDollars: 69,
  rating: 5,
  reviewCount: 22,
  isInsider: true,
  description:
    "Hi I'm Leeann the owner of Aromalee Shop! I make hand poured healing aromas which include candles, car diffusers, roller balls, wax melts, tea lights, & more. They are scented with 100% essential oils bringing you aromatherapy with any product! They are also infused with crystals and herbs for additional healing effects. I became vegan a few years ago and started to seek eco friendly products. I quickly noticed the gap in sustainable options I had for more than just food. Thats when I began to have dreams of creating my own products to share with my family, friends, and community! Here I am now bringing you thoughtfully created vegan products from all around the U.S! I am currently traveling with my pup Lola in the south west. I'm so excited for what I have to offer now and looking forward to what's coming next! Stay tuned - Leelee",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:18.648Z",
    importedBy: "entity-db-cli",
  },
};
